// App.tsx
import React, { useEffect } from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "./core/auth";
import Layout from "./componets/Layout/Layout";
import LoginPage from "./pages/LoginPage/LoginPage";
import AttendancePage from "./pages/AttendancePage/AttendancePage";
import { ColorProvider } from "./core/company"; // ojo: path correcto .tsx
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SuccessfulRegistration from "./pages/SuccessfulRegistration/SuccessfulRegistration";
import StartingOverlay from "./componets/StartingOverlay/StartingOverlay";
import { CollaboratorProvider } from "./core/collaborator/CollaboratorContext";
import { BiometricProvider } from "./Context/Biometric/biometric.Context";
import { store } from "./app/store";
import AppModals from "./componets/AppModals/AppModals";
import { Provider } from "react-redux";
import Hotjar from '@hotjar/browser';
// // Webpack: asegurate DefinePlugin setea estas envs
// const cfg = process.env.REACT_APP_ENV ? ((env as any)[process.env.REACT_APP_ENV] ?? {}) : {};

// // Interceptor ANTES de cualquier login
// installLoginColorMock({
//   client: axios,
//   apiLoginUrl: cfg.API_LOGIN, // puede ser completa o relativa
//   patterns: ["/auth/login", "/v1/auth/login"], // reforzamos el match
//   enabled:
//     process.env.REACT_APP_MOCK_RANDOM_COLORS === "1" || process.env.NODE_ENV === "development",
// });

const siteId = 6614974; // Reemplaza con tu Site ID
const hotjarVersion = 6;

function PublicOnly({ children }: { children: JSX.Element }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/" replace /> : children;
}

function RequireAuthShell() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <StartingOverlay label="Cargando" />;
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return (
    <Provider store={store}>
      <BiometricProvider>
        <ColorProvider>
          <Layout>
            <Outlet />
            <AppModals />
          </Layout>
        </ColorProvider>
      </BiometricProvider>
    </Provider>
  );
}

export default function App() {
  // eslint-disable-next-line no-console
  useEffect(() => {
    const isProd =
      process.env.NODE_ENV === "production"
    if (isProd) {
      Hotjar.init(siteId, hotjarVersion);
    }
  }, []);
  return (
    <AuthProvider>
      <CollaboratorProvider>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicOnly>
                <LoginPage />
              </PublicOnly>
            }
          />
          <Route element={<RequireAuthShell />}>
            <Route index element={<AttendancePage />} />
            <Route path="/confirm" element={<SuccessfulRegistration />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
        <ToastContainer />
      </CollaboratorProvider>
    </AuthProvider>
  );
}
